<template>
  <Alert v-if="rows.length === 0" type="info">Nenhum resultado encontrado.</Alert>

  <div class="table-responsive" v-else>
    <table class="table" :class="[
      { 'table-striped': striped !== null },
      { 'table-bordered': bordered !== null },
      { 'table-hover': hover !== null },
      { 'table-sort': sort !== null }
    ]">
      <thead>
        <tr>
          <th
            v-for="(column, index) in columns"
            :key="`column${index}`"
            ref="column"
            :data-th-name="sort !== null && column.name ? column.name : null"
            :data-th-label="sort !== null && column.label ? column.label : null"
            :data-th-order="sort !== null ? 'none' : null"
            @click="sort !== null && column.name !== 'id' && column.name !== 'actions' ? sortColumn($event) : null"
          >
            {{ column.name !== 'id' ? (column.label || column) : '' }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(keys, index) in rows" :key="`row${index}`">
          <td v-for="(key, index) in keys" :key="index" ref="row">

            <!-- if datatable and property = id -->
            <label
              v-if="sort !== null && index === 'id'"
              class="custom-checkbox"
            >
              <input
                type="checkbox"
                ref="checkbox"
                v-model="items"
                :value="key"
                @change="selectItems"
              >
              <span class="checkmark"></span>
            </label>

            <!-- actions -->
            <div v-else-if="index === 'actions'" class="block text-center">
              <span v-for="option in key" :key="option">
                <Button
                  v-if="option === 'edit'"
                  :href="{ name: $route.name, params: { type: 'editar', id: keys['id'] } }"
                  title="Editar"
                  variant="success"
                  size="sm"
                  data-toggle="tooltip"
                >
                  <i class="fa fa-pencil"></i>
                </Button>

                <Button
                  v-if="option === 'delete'"
                  title="Excluir"
                  variant="danger"
                  size="sm"
                  data-toggle="tooltip"
                  @onClick="deleteItem([keys['id']])"
                >
                  <i class="fa fa-trash"></i>
                </Button>
              </span>
            </div>

            <!-- other properties -->
            <span v-else v-html="key">Actions</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    striped: {
      type: String,
      default: null
    },
    bordered: {
      type: String,
      default: null
    },
    hover: {
      type: String,
      default: null
    },
    sort: {
      type: String,
      default: null
    }
  },
  watch: {
    rows () {
      this.resetCheckbox()
    }
  },
  data () {
    return {
      items: []
    }
  },
  methods: {
    resetSortColumn () {
      const ths = this.$refs.column
      const tds = this.$refs.row
      let i

      for (i = 0; i < ths.length; i++) {
        ths[i].dataset.thOrder = 'none'
        ths[i].classList.remove('active')
      }

      for (i = 0; i < tds.length; i++) {
        tds[i].classList.remove('active')
      }
    },

    resetCheckbox () {
      setTimeout(() => {
        const checkboxes = this.$refs.checkbox
        let checkbox

        for (let i = 0; i < checkboxes.length; i++) {
          checkbox = checkboxes[i]
          checkbox.checked = false
        }
      }, 20)
    },

    activeColumn (e) {
      const tds = document.querySelectorAll(`tbody td:nth-child(${e.target.cellIndex + 1})`)
      e.target.classList.add('class', 'active')

      for (let i = 0; i < tds.length; i++) {
        tds[i].classList.add('active')
      }
    },

    sortColumn (e) {
      const th = e.target

      if (th.dataset.thOrder === 'none' || th.dataset.thOrder === 'asc') {
        this.resetSortColumn()
        this.activeColumn(e)
        th.dataset.thOrder = 'desc'
      } else {
        this.resetSortColumn()
        this.activeColumn(e)
        th.dataset.thOrder = 'asc'
      }

      const { thName, thLabel, thOrder } = th.dataset
      this.$emit('sortColumn', { thName, thLabel, thOrder })
    },

    deleteItem (id) {
      this.$emit('deleteItem', id)
    },

    selectItems () {
      this.$emit('selectItems', this.items)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'table';
</style>



// WEBPACK FOOTER //
// src/components/table/Table.vue